import { useAuthInfo } from "@propelauth/react";
import { DataTable } from "../ui/dataTable";
import { BiddingProps } from "./BiddingSummaryView";
import { useNavigate, useParams } from "react-router-dom";
import { postWithToken } from "../../api/apiBase";
import { blank_bid } from "./bidding_model";
import { Button } from "../ui/button";

function BiddingBuilderSummaryView(props: BiddingProps) {
  const { accessToken } = useAuthInfo();
  const { project_id } = useParams<{ project_id: string }>();
  const navigate = useNavigate();

  const onCreateBid = () => {
    postWithToken(
      `/projects/${project_id}/bidding/create`,
      JSON.stringify(blank_bid()),
      accessToken as string
    )
      .then((new_data) => {
        // console.log(new_data)
        navigate(`/project/${project_id}/bid/${new_data.id}`);
      })
      .catch((error) => {
        console.error("Error creating bid:", error);
      });
  };

  const onViewChart = () => {
    navigate(`/project/${project_id}/bidding-chart`)
  }

  return (
    <div className="relative">
      <div>
        <div className="absolute -top-[55px] right-0">
        <Button variant="outline" type="button" onClick={onViewChart} className="mr-3">
          View chart
          </Button>
          <Button variant="outline" onClick={(e) => onCreateBid()}>
            New Bid
          </Button>
        </div>
      </div>
      <div>
        <DataTable
          data={props.tableData}
          columns={props.tableColumns}
          handleRowClick={props.handleRowClick}
        />
      </div>
    </div>
  );
}

export default BiddingBuilderSummaryView;
